import React from "react"
import isEmpty from "lodash/isEmpty"
import classNames from "classnames"
import styles from "./styles.module.css"

const Select = ({
  value = "",
  id = undefined,
  name = undefined,
  includeDefault = false,
  options,
  customOptions,
  disabled,
  error,
  onBlur = () => {},
  onChange = () => {},
  style = {},
}) => {
  const optionValues = customOptions
    ? []
    : Array.isArray(options[0])
    ? options.map((option) => option[1])
    : options

  return (
    <React.Fragment>
      <select
        className={classNames(styles.select, { [styles.error]: !!error })}
        value={value || ""}
        name={name}
        id={id || name}
        style={style}
        onBlur={onBlur}
        onChange={onChange}
        disabled={disabled}
      >
        {!customOptions &&
        !isEmpty(value) &&
        !optionValues.includes(value || "") ? (
          <option value={value}>{`Others (${value})`}</option>
        ) : includeDefault ? (
          <option />
        ) : null}

        {customOptions
          ? customOptions
          : options.map((option, index) => (
              <option
                key={`${name}-option-${index}`}
                value={
                  Array.isArray(option) && option.length === 2
                    ? option[1]
                    : option
                }
              >
                {Array.isArray(option) && option.length === 2
                  ? option[0]
                  : option}
              </option>
            ))}
      </select>

      {error ? <p className={styles["error-message"]}>{error}</p> : null}
    </React.Fragment>
  )
}

export default Select
